<script>

</script>

<style>
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 75px;
    width: 100%;
  }

  @media screen and (max-width: 900px) {
    .grid {
      grid-template-columns: 1fr;
      justify-items: center;
    }
    .container {
      padding-bottom: 50px !important;
    }
    .image {
      display: flex;
      justify-content: center;
      padding-bottom: 20px;
    }
  }

  .container {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .title h1 {
    margin-bottom: 0px;

    padding-bottom: 0px;
  }
  .title h4 {
    margin-top: 0px;

    padding-top: 0px;
  }

  .title img {
    height: 250px;
    width: 200px;
    object-fit: cover;
    border-radius: 2px;
    box-shadow: 9px 9px 18px #d9d9d9, -9px -9px 18px #e7e7e7;
  }
  .image {
    padding-bottom: 20px;
  }

  .title {
    display: flex;
    flex-direction: column;
  }
</style>

<div class="container" id="team">
  <div class="grid">
    <div>
      <div class="title">
        <div class="image">
          <img src="ronny.jpg" alt="" />
        </div>
        <div class="text">
          <h1>Ronny Widerberg</h1>
          <h4>Founder & senior consultant</h4>
        </div>
      </div>
      <div class="text">
        Ronny has 25 years of experience implementing Lean production on an
        international level. Both working in companies and as a consultant. He
        has experience from many different positions within the industry; as an
        operator, team leader, production manager, quality manager, development
        manager, senior Lean Change Manager as well as being a Lean consultant
        process-, steel-, food-, automotive- and energy industry.
        <br />
        <br />
        <b>Ronnys areas of expertise are:</b>
        <ul>
          <li>Lean Leadership</li>
          <li>Production systems – Build up/Development</li>
          <li>5S</li>
          <li>Performance Management</li>
          <li>Standardized work</li>
          <li>SMED – Single Minute Exchange of Dies</li>
          <li>Autonomous operator maintenance</li>
          <li>Problem solving – A3</li>
          <li>Kaizen – continuous improvement</li>
          <li>TPM – Total Productive Mainteneance</li>
        </ul>
      </div>
    </div>
    <div>
      <div class="title">
        <div class="image">
          <img src="linus.jpg" alt="" />
        </div>
        <div class="text">
          <h1>Linus Larsson</h1>
          <h4>Consultant</h4>
        </div>
      </div>
      <div class="text">
        Linus has 5 years of experience implementing Lean systems in the value
        chains on an international level. Both on the shopfloor and in white
        collar environments. Linus also has a high profficiency in product- and
        web development.
        <br />
        <br />
        <b>Linus areas of expertise are:</b>
        <ul>
          <li>Team organization</li>
          <li>Performance Management</li>
          <li>5S</li>
          <li>Standardized work</li>
          <li>Value stream mapping</li>
          <li>Problem solving – A3</li>
          <li>Discrete event simulations</li>
          <li>Programming</li>
          <li>Mechanics</li>
          <li>Product development</li>
          <li>Web development</li>
        </ul>
      </div>
    </div>
  </div>
</div>
